import config from 'src/config'

function load(component) {
  return () => import(`src/${component}.vue`)
}

const MODULE_PATH = '/evoucher/management/'

export default [
  {
    path: MODULE_PATH,
    component: load('containers/Full'),
    name: 'eVoucher',
    meta: {
      title: 'Common.menu.eVoucher',
      menuItem: true,
      sorting: config.sidebar.menu.sorting.modules.voucher,
      icon: 'card_giftcard',
    },
    children: [
      {
        path: MODULE_PATH + 'voucher/list',
        component: load('application/evoucher/components/EvoucherList'),
        name: 'eVoucher Redemption List',
        meta: {
          title: 'Common.menu.sub.eVoucher.eVoucherList',
          icon: 'attach_money',
          menuItem: true,
          sorting: 501,
        },
      },
      {
        path: MODULE_PATH + 'view/[:evoucherID]',
        component: load('application/evoucher/components/EvoucherArea'),
        name: 'eVoucher Redemption Details',
        props: true,
        meta: {
          title: 'Common.menu.sub.eVoucher.eVoucherArea',
          icon: 'attach_money',
          menuItem: false,
          sorting: 502,
        },
      },
    ],
  },
]
